"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldTrack = exports.isJson = exports.isInteger = exports.isFloat = exports.isString = exports.isBoolean = exports.mismatchedDefaultError = void 0;
const types_1 = require("./types");
exports.mismatchedDefaultError = (type, name) => 
// tslint:disable-next-line: max-line-length
`Attempted to grab ${type} for Dynamic Value ${name} which has mismatching default`;
function isBoolean(value) {
    return typeof value === 'boolean';
}
exports.isBoolean = isBoolean;
function isString(value) {
    return typeof value === 'string';
}
exports.isString = isString;
function isFloat(value) {
    return typeof value === 'number';
}
exports.isFloat = isFloat;
function isInteger(value) {
    return typeof value === 'number' && Number.isInteger(value);
}
exports.isInteger = isInteger;
function isJson(value) {
    const type = typeof value;
    return (type !== 'boolean' &&
        type !== 'string' &&
        type !== 'number' &&
        type !== 'undefined');
}
exports.isJson = isJson;
/**
 * Evaluate a given DV node to determine if this exposure should be tracked,
 * according to the tracking mode.
 *
 * @param node DV meta node
 * @param rng For testing. The RNG used to percentage bucket
 */
exports.shouldTrack = (node, rng = Math.random) => {
    switch (node.trackingMode) {
        case types_1.TrackingMode.Debug:
            return (rng() * 100) % 100 < 10;
        case types_1.TrackingMode.Experiment:
            return true;
        case types_1.TrackingMode.Silent:
            return false;
        default:
            return false;
    }
};
//# sourceMappingURL=utils.js.map